var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 354,
    height: 303.402,
    viewBox: "0 0 354 303.402",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shadwork-logo",
    transform: "translate(-20.28 -9.93)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1086",
    "data-name": "Path 1086",
    d: "M0,.16c30.569,20.2,56.054,42.182,75.886,65.466,20.767,24.381,35.164,49.988,42.839,76.194a140.257,140.257,0,0,0,.734-73.877A168.125,168.125,0,0,0,97.917,19.909Z",
    transform: "translate(109.469 72.484)",
    fill: "#7fc6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1087",
    "data-name": "Path 1087",
    d: "M27.045,81.534a159.141,159.141,0,0,1,51.53,19.449c33.625,19.446,64.838,51.706,91.752,94.83-4.345-8.791-10.387-20.548-17.953-33.789a612.433,612.433,0,0,0-35.993-54.942C95.838,79.666,55.414,37.58,0,0H0Q7.639,18.79,15.306,42.2C19.795,55.931,23.679,69.227,27.045,81.534Z",
    transform: "translate(29.087 169.646) rotate(-59)",
    fill: "#5ea6c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1088",
    "data-name": "Path 1088",
    d: "M229.6,190.091C177.816,134.2,117.17,98.127,53.25,85.184c50.783-10.755,102.582-4.817,151.571,17.375Z",
    transform: "translate(128.468 102.099)",
    fill: "#5ea6c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1089",
    "data-name": "Path 1089",
    d: "M159.6,180.2a171.106,171.106,0,0,0-16.543-50.087C126.718,97.43,99.774,67.116,63.85,41c7.337,4.2,17.136,10.079,28.165,17.386a503.736,503.736,0,0,1,45.847,34.94c22.787,19.934,58.2,59.158,89.78,112.856h0c-10.436-4.787-22.149-9.771-35.137-14.67C181.066,187.2,170.037,183.449,159.6,180.2Z",
    transform: "translate(87.773 -17.353)",
    fill: "#bff9e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1090",
    "data-name": "Path 1090",
    d: "M-4.257,258.722c41.653-40.279,76.715-83.1,104.36-127.46,27.291-43.813,47.183-88.779,59.224-133.877a523.86,523.86,0,0,1-3.293,99.968,581.03,581.03,0,0,1-19.313,91.177Z",
    transform: "translate(221.289 14.746) rotate(43)",
    fill: "#7fc6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1091",
    "data-name": "Path 1091",
    d: "M0,138.79c104.682-30.658,226.373-50.081,354-56.5A2655.977,2655.977,0,0,0,82.468,84.268Q41.3,111.543,0,138.79Z",
    transform: "translate(20.28 147.432)",
    fill: "#bff9e4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileImage);
export default __webpack_public_path__ + "static/media/profile_image.46d8c3f461b71ce209976990bf50f3c7.svg";
export { ForwardRef as ReactComponent };